import React from 'react';

// Shared track definitions + course image used by the "Included Courses" section across program pages.
export const TRACKS = [
  { name: 'Software Development',    accent:'#2563EB', bg:'#EFF6FF', border:'#BFDBFE' },
  { name: 'Data & Analytics',        accent:'#16A34A', bg:'#F0FDF4', border:'#BBF7D0' },
  { name: 'Quality Engineering',     accent:'#7C3AED', bg:'#FAF5FF', border:'#DDD6FE' },
  { name: 'Design & Marketing',      accent:'#EA580C', bg:'#FFF7ED', border:'#FED7AA' },
  { name: 'Cloud, DevOps & Security',accent:'#0EA5E9', bg:'#F0F9FF', border:'#BAE6FD' },
  { name: 'Artificial Intelligence', accent:'#4338CA', bg:'#EEF2FF', border:'#C7D2FE' },
  { name: 'Other',                   accent:'#64748B', bg:'#F8FAFC', border:'#E2E8F0' },
];

export const getTrack = (name = '') => {
  const n = name.toUpperCase();
  if (n.includes('JAVA') || n.includes('FULL STACK') || n.includes('MERN') || n.includes('MEAN') || n.includes('PYTHON') || n.includes('REACT') || n.includes('ANGULAR') || n.includes('NODE') || n.includes('EXPRESS') || n.includes('FRONT END') || n.includes('WEB DEV')) return 'Software Development';
  if (n.includes('DATA') || n.includes('SCIENCE') || n.includes('POWER BI') || n.includes('PYSPARK') || n.includes('TABLEAU') || n.includes('MACHINE LEARNING') || n.includes('ANALYTICS') || n.includes('ANALYST') || n.includes('ENGINEER')) return 'Data & Analytics';
  if (n.includes('AUTOMATION') || n.includes('TESTING') || n.includes('PLAYWRIGHT') || n.includes('SELENIUM') || n.includes('QA')) return 'Quality Engineering';
  if (n.includes('UI') || n.includes('UX') || n.includes('DESIGN') || n.includes('MARKETING') || n.includes('BUSINESS') || n.includes('HR') || n.includes('HUMAN RESOURCE')) return 'Design & Marketing';
  if (n.includes('JENKINS') || n.includes('DEVOPS') || n.includes('CYBER') || n.includes('SECURITY') || n.includes('CLOUD') || n.includes('AWS') || n.includes('AZURE') || n.includes('DOCKER') || n.includes('KUBERNETES')) return 'Cloud, DevOps & Security';
  if (n.includes('GENERATIVE') || n.includes('AGENTIC') || n.includes('LLM') || n.includes('ARTIFICIAL') || n.includes('AI ') || n.includes(' AI')) return 'Artificial Intelligence';
  return 'Other';
};

// Course image with colored initials fallback when no image is available.
export const CourseImage = ({ imgPath, name, accent, bg }) => {
  const [failed, setFailed] = React.useState(false);
  const initials = (name || '').split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase();

  if (!imgPath || failed) {
    return (
      <div style={{ height:140, background:`linear-gradient(135deg, ${bg}, ${accent}22)`, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:8, flexShrink:0 }}>
        <div style={{ width:56, height:56, borderRadius:14, background:accent, display:'flex', alignItems:'center', justifyContent:'center', boxShadow:`0 4px 16px ${accent}55` }}>
          <span style={{ fontSize:20, fontWeight:900, color:'#fff' }}>{initials}</span>
        </div>
        <span style={{ fontSize:11, fontWeight:600, color:accent, opacity:0.7, maxWidth:160, textAlign:'center', lineHeight:1.3, padding:'0 8px' }}>{name}</span>
      </div>
    );
  }

  return (
    <img
      src={imgPath}
      alt={name}
      style={{ width:'100%', height:140, objectFit:'cover', display:'block', flexShrink:0 }}
      onError={() => setFailed(true)}
    />
  );
};
